import { useEffect } from 'react';
import { useKeyPress } from 'reactflow';
import { useRecoilState } from 'recoil';
import interactions from '~/components/page/Automation/v2/state/interactions';

const useBuilderBindings = () => {
  const [activeInteraction, setActiveInteraction] =
    useRecoilState(interactions);

  const escKeyPressed = useKeyPress('Escape');

  useEffect(() => {
    if (!escKeyPressed) return;

    if (activeInteraction?.type === 'connectAction') {
      setActiveInteraction(null);
      return;
    }

    if (activeInteraction?.type === 'copyAction') {
      const canRevertToSelecting =
        activeInteraction.phase === 'pasting' &&
        activeInteraction.allowSelecting;

      setActiveInteraction(
        canRevertToSelecting
          ? { ...activeInteraction, phase: 'selecting' }
          : null,
      );
    }
  }, [escKeyPressed, activeInteraction, setActiveInteraction]);
};

export default useBuilderBindings;
